import { Link } from "react-router-dom";

const Banner = (props) => {
  return (
    <Link to={`/categories/${props.img === 3 ? 3 : 27}`}>
      <img src={`/public/assets/banners${props.img}.png`} className="banner" />
    </Link>
  );
};

export default Banner;
